import { Component, OnDestroy } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { CommonModule } from "@angular/common";
import { AppLayoutComponent } from "./shared/components/layout/app-layout/app-layout.component";
import { NavigationService } from "./core/services/navigation.service";
import { AuthService } from "./core/services/auth.service";
import { UserModel } from "./core/models/user";
import { LoadingComponent } from "./shared/components/loading/loading.component";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-root",
  standalone: true,
  imports: [CommonModule, RouterOutlet, AppLayoutComponent, LoadingComponent],
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  title = "front-ti-bot-space";
  currentPage$ = this.navigationService.currentPage$;
  user: UserModel | null = null;
  isLoading = true;

  constructor(private navigationService: NavigationService, private authService: AuthService) {
    this.authService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.user = user;
        this.isLoading = false;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNavigate(page: string): void {
    this.navigationService.navigateTo(page);
  }
}
